export default {
  realtimeStatus: false,
  loading: false,
  skip_quote_rules: false,
  logistic_contract_mode: false,
  shipment_type: false,
  delivery_method_list: [],
  contract_list: [],
  contract_select_object_ids: {},
  quoteFreightVolume: {
    origin_zip_code: '',
    destination_zip_code: '',
    volumes: [{
      weight: '',
      height: '',
      width: '',
      length: '',
      cost_of_goods: '',
      replicateQtd: 1,
    }],
    additional_information: {
      federal_tax_payer_type: 'cpf',
      delivery_method_ids: [],
      exempt_from_icms: true,
      additional_business_days: 0,
      extra_cost_percentage: 0,
      extra_cost_absolute: 0,
    },
  },
  quoteFreightProduct: {
    origin_zip_code: '',
    destination_zip_code: '',
    products: [{
      quantity: 1,
      sku_id: '',
      description: '',
      weight: '',
      height: '',
      width: '',
      length: '',
      cost_of_goods: '',
      replicateQtd: 1,
      can_group: false,
    }],
    additional_information: {
      federal_tax_payer_type: 'cpf',
      delivery_method_ids: [],
      exempt_from_icms: true,
      extra_cost_percentage: 0,
      extra_cost_absolute: 0,
      additional_business_days: 0,
    },
  },
  quoteFreightComparison: {
    origin_zip_code: '',
    destination_zip_code: '',
    volumes: [{
      weight: '',
      height: '',
      width: '',
      length: '',
      cost_of_goods: '',
      replicateQtd: 1,
    }],
    additional_information: {
      federal_tax_payer_type: 'cpf',
      delivery_method_ids: [],
      exempt_from_icms: true,
      additional_business_days: 0,
      extra_cost_percentage: 0,
      extra_cost_absolute: 0,
    },
  },
  quoteFreight: {
    excluded_methods: [],
    logistic_provider: {
      delivery_methods: [],
    },
    order: {
      qty_volumes: null,
    },
  },
  originZipCode: {
    zip_code: '',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/store/states.js